function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { Row, Col, Input as ReactInput } from 'reactstrap';
import { useWorkFlow, UPDATE_USER, UPDATE_CAPTCHA } from "./contexts/workflow";
import { useParams } from "./contexts/parameters";
import Connect from "./connect";
import { _Captcha as Captcha } from "./core/common";
import { _translate, _Notifications, _Security } from "../services/core";
import Input from "./end/input";
var ValidateDiagnostic = function ValidateDiagnostic() {
  var _useWorkFlow = useWorkFlow(),
    collector = _useWorkFlow.collector,
    dispatcher = _useWorkFlow.dispatcher;
  var _useParams = useParams(),
    parameters = _useParams.parameters;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    isEmailValid = _useState2[0],
    setIsEmailValid = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    firstEmail = _useState4[0],
    setFirstEmail = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    secondEmail = _useState6[0],
    setSecondEmail = _useState6[1];
  var _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    isFirstEmailValid = _useState8[0],
    setFirstEmailValid = _useState8[1];
  var _useState9 = useState(null),
    _useState10 = _slicedToArray(_useState9, 2),
    isAnonymous = _useState10[0],
    setAnonymous = _useState10[1];
  var email = parameters.email;

  /** @todo change, getting regex from stackoverflow. */
  function validateEmail(email) {
    var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }
  var handleFirstEmailOnChange = function handleFirstEmailOnChange(e) {
    var value = e.target.value;
    if (!validateEmail(value)) {
      setFirstEmailValid(false);
    } else {
      setFirstEmailValid(true);
    }
    setFirstEmail(value);
  };
  var writeEmail = function writeEmail(e) {
    var value = e.target.value;
    setSecondEmail(value);
    if (value !== firstEmail) {
      setIsEmailValid(false);
      return;
    }
    if (validateEmail(value)) {
      dispatcher({
        type: UPDATE_USER,
        value: value
      });
      setIsEmailValid(true);
    } else {
      setIsEmailValid(false);
      if (collector.user) {
        dispatcher({
          type: UPDATE_USER,
          value: null
        });
      }
    }
  };
  var handleCaptchaSuccess = function handleCaptchaSuccess(token, key) {
    dispatcher({
      type: UPDATE_CAPTCHA,
      value: {
        token: token,
        key: key
      }
    });
  };
  var handleCaptchaFailure = function handleCaptchaFailure() {
    _Notifications.warning(_translate('collectorapp_captcha_title'), _translate('collectorapp_captcha_failed'));
    dispatcher({
      type: UPDATE_CAPTCHA,
      value: null
    });
  };
  var createStringValidation = function createStringValidation() {
    var str = 'collectorapp_send_responses';
    if (collector && collector.diag) {
      str += "_".concat(collector.diag.id);
      if (collector.diag.community) {
        str += "_".concat(collector.diag.community.id);
      }
    }
    return str;
  };
  var generateAnonymousEmail = function generateAnonymousEmail() {
    var username = "anonymous_".concat(Date.now(), "@wever.fr");
    dispatcher({
      type: UPDATE_USER,
      value: username
    });
    setIsEmailValid(true);
  };
  useEffect(function () {
    if (!email) {
      return;
    }
    dispatcher({
      type: UPDATE_USER,
      email: email
    });
  }, []);
  useEffect(function () {}, [collector.need_connection]);

  /* if (null === isAnonymous) {
    return (
      <Row className="justify-content-center collectorConnectContainer">
        <Col sm="12" md="6">
          <div>
            <div className="collectorQuestionName">
              <p>{_translate('collectorapp_is_anonymous_title')}</p>
            </div>
            <br />
            <div className="collectorQuestionDescription">{_translate('collectorapp_is_anonymous_description')}</div>
            <br />
            <Row>
              <Col className="col-12">
                <InputGroup
                  className="CollectorQuestionResponseInputgroup d-flex justify-content-center"
                  key={`radio_${Math.random()}`}
                >
                  <Label className={`radio-hover`}>
                    <ReactInput
                      type="radio"
                      onChange={(e) => {
                        generateAnonymousEmail();
                        setAnonymous(true);
                      }}
                    />
                    {_translate('collectorapp_is_anonymous_yes')}
                  </Label>
                  <br />
                </InputGroup>
              </Col>
              <Col className="col-12">
                <InputGroup
                  className="CollectorQuestionResponseInputgroup d-flex justify-content-center"
                  key={`radio_${Math.random()}`}
                >
                  <Label className={`radio-hover`}>
                    <ReactInput type="radio" onChange={(e) => setAnonymous(false)} />
                    {_translate('collectorapp_is_anonymous_false')}
                  </Label>
                  <br />
                </InputGroup>
              </Col>
            </Row>
            <br />
          </div>
        </Col>
      </Row>
    );
  }
   if (true === isAnonymous) {
    return (
      <Row className="justify-content-center collectorConnectContainer">
        <Col sm="12" md="6">
          <Col className="mt-2">
            <Captcha number="6" onSuccess={handleCaptchaSuccess} onFailure={handleCaptchaFailure} />
          </Col>
        </Col>
      </Row>
    );
  } */

  return /*#__PURE__*/React.createElement(Row, {
    className: "justify-content-center collectorConnectContainer"
  }, /*#__PURE__*/React.createElement(Col, {
    sm: "12",
    md: "6"
  }, /*#__PURE__*/React.createElement("h5", null, _translate(createStringValidation())), /*#__PURE__*/React.createElement("br", null), !_Security.isAuthenticated() && !email ? /*#__PURE__*/React.createElement(React.Fragment, null, collector.need_connection && !_Security.isAuthenticated() ? /*#__PURE__*/React.createElement(Connect, {
    required: true
  }) : /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    className: "col-12 d-flex justify-content-left"
  }, /*#__PURE__*/React.createElement("h6", null, _translate('fill_email_to_save'))), /*#__PURE__*/React.createElement(Col, {
    className: "col-12"
  }, /*#__PURE__*/React.createElement(Input, {
    type: "email",
    onChange: handleFirstEmailOnChange,
    errorMessage: firstEmail && firstEmail.length > 5 && !isFirstEmailValid ? 'collectorapp_format_invalid' : null,
    label: "collectorapp_fill_email"
  })), /*#__PURE__*/React.createElement(Col, {
    className: "col-12 mt-4"
  }, /*#__PURE__*/React.createElement(Input, {
    type: "email",
    onChange: writeEmail,
    errorMessage: firstEmail && secondEmail && secondEmail.length > 5 && !isEmailValid ? 'collectorapp_email_need_to_be_same' : null,
    label: "collectorapp_confirm_email"
  })), /*#__PURE__*/React.createElement(Col, {
    className: "mt-2"
  }, /*#__PURE__*/React.createElement(Captcha, {
    number: "6",
    onSuccess: handleCaptchaSuccess,
    onFailure: handleCaptchaFailure
  })))) : !collector.captcha && /*#__PURE__*/React.createElement(Col, {
    className: "mt-2"
  }, /*#__PURE__*/React.createElement(Captcha, {
    number: "6",
    onSuccess: handleCaptchaSuccess,
    onFailure: handleCaptchaFailure
  }))));
};
export default ValidateDiagnostic;